import { useTranslation } from 'react-i18next';
import { ExpirationStatus } from '@/helpers/contactClassificationExpiration';
import hourglassIcon from '@/assets/icons/hourglass.svg';
import expiredIcon from '@/assets/icons/expired.svg';
import alertIcon from '@/assets/icons/alert2.svg';
import styles from './ExpirationStatusFilters.module.scss';

/** The expiration states offered as filters, in display order. */
const EXPIRATION_FILTER_ICONS: Record<string, string> = {
  [ExpirationStatus.PendingApproval]: hourglassIcon,
  [ExpirationStatus.Expired]: expiredIcon,
  [ExpirationStatus.ExpiringSoon]: alertIcon,
};

interface ExpirationStatusFiltersProps {
  /** Number of classifications per expiration status. */
  counts: Record<string, number>;
  selectedExpiration: ExpirationStatus | null;
  onToggle: (expirationStatus: ExpirationStatus) => void;
}

/**
 * The classification expiration filter buttons, shared by the fund supporteds screen and the
 * supporteds management screen so both look and behave the same.
 */
const ExpirationStatusFilters = ({ counts, selectedExpiration, onToggle }: ExpirationStatusFiltersProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-6">
      {Object.entries(EXPIRATION_FILTER_ICONS).map(([expirationStatus, icon]) => {
        const count = counts[expirationStatus] || 0;
        const isSelected = selectedExpiration === expirationStatus;

        return (
          <button
            key={expirationStatus}
            onClick={() => onToggle(expirationStatus as ExpirationStatus)}
            className={`${styles.expirationFilterButton} ${isSelected ? styles.selected : ''}`}
          >
            <div className={`${styles.iconBackground} ${isSelected ? styles.selected : ''}`}>
              <img
                //TODO: add the icons for the selected state
                src={icon}
                alt="Filter icon"
                className="w-6 h-6"
              />
            </div>
            <div className={`flex flex-col items-start ${isSelected ? 'text-(--font-body-4)' : 'text-(--font-body-1)'}`}>
              <span className="body-md-bold">
                {t('classificationsCount', { count })}
              </span>
              <span className="body-sm-regular">
                {t(`filter.${expirationStatus}`)}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default ExpirationStatusFilters;
